import { StartTripModel } from '../models/home/StartTrip.model';
import getTime from '../utils/getTimePeriod';
import { IONICWrapper } from './common';
import { APPOINTMENT_INDICATOR_STATE_VALUE, BORDER_CROSSING, Navigate_Module_Web, RELAY, Roles, ROLES } from './constants';
import { dayjs } from './Date/DateUtil';

export const getFormatRoles = () => {
  const roles = IONICWrapper.details.auth.user.roles && IONICWrapper.details.auth.user.roles.map((role:any) => ROLES[role]);
  return roles || [];
}

export const getAppointmentTime = (stop: any) => {
  let fromTime = '';
  let toTime = '';
  if (stop.appointmentEarlyDateTime || stop.appointmentLateDateTime) {
    fromTime = stop.appointmentEarlyDateTime || '';
    toTime = stop.appointmentLateDateTime || '';
  } else if (stop.plannedArrivalDateTime || stop.plannedDepartureDateTime) {
    fromTime = stop.plannedArrivalDateTime || '';
    toTime = stop.plannedDepartureDateTime || '';
  }
  return getTime(fromTime || '', toTime || '');
};

export const getAppointmentIndicatorTime = (stop: any) => {
  let fromTime = null;
  let toTime = null;
  if (stop.appointmentEarlyDateTime || stop.appointmentLateDateTime) {
    fromTime = stop.appointmentEarlyDateTime || '';
    toTime = stop.appointmentLateDateTime || '';
  } 
  return (fromTime!== null || toTime!== null)?getTime(fromTime || '', toTime || ''): null;
};

export const appointmentState = (stops: any[],props : any) => {
 let appointmentStops : any[]=  stops?.filter((stop : any) => stop?.stopType === "P" || stop?.stopType === "D" || stop?.stopType === BORDER_CROSSING || stop?.stopType === RELAY ) 
 let appointmentStateValue : string = appointmentStops?.find((stop : any) => stop?.appointmentState === APPOINTMENT_INDICATOR_STATE_VALUE)?.appointmentState
 return appointmentStateValue
}

export const sameDateFreightCheckValue = (stops: any[]) => {
  let warningLoadStop : any =  stops?.find((stop : any) => stop?.stopType === "P");
  let warningLoadStopDate : any = dayjs(warningLoadStop?.appointmentTo).tz(warningLoadStop?.timeZone).format("DD-MM-YYYY");
  const currentDate : any = dayjs().tz(warningLoadStop?.timeZone).format("DD-MM-YYYY");   
  return warningLoadStopDate === currentDate
 }

/**
 * @param status 
 * isHardStop method, detects the hardstop response,
 * coming in message params in API response.
 * if === true, hardstop is detected, trailer ID is invaild, 
 * we need to stop flow the TRAILER OUT value to TRAILER IN for next stop
 * if === false, trailer ID is valid, flow change is unaffected
 * @returns 
 */
export const isHardStop = (status: string) => {
  if(status) return status.includes("hard-stop-message")
}

const getStopService = (stopDetail: any) => {
  const stopActivity = stopDetail.specialServices || stopDetail.stopActivity || [];
  return (stopActivity && stopActivity.map((item: any) => item.name).join(',')) || '';
};

export const formatedData = (
  data: any,
  fdProp: string,
  tdProp: string,
  idProp: string,
  tMProp: string,
  showInitial?: boolean
) => {
  const stopDetailsList: any = [];
  if (data && fdProp && tdProp && idProp) {
    data.forEach((load: any) => {
      const stopDetails: any = {};
      let loadStop =
        load.loadStop &&
        load.loadStop.slice().sort((load1: any, load2: any) => {
          if (load1.sequenceNo && load2.sequenceNo) {
            return load1.sequenceNo - load2.sequenceNo;
          }
          if (load1.stopSequence && load2.stopSequence) {
            return load1.stopSequence - load2.stopSequence;
          }
          return 0;
        });
      loadStop = idDrop(idProp, loadStop);
      const origin = getLoadStopOriginDetails(loadStop);
      const destination = getDestinationDetails(loadStop);
      stopDetails.loadId = load[idProp];
      getOrigin(origin, stopDetails, idProp, fdProp, tdProp);
      getDestination(destination, stopDetails, idProp, fdProp);
      stopDetails.trailer = load[tMProp];
      stopDetails.price = getLoadPrice(load);
      showInitialDriverName(showInitial, load, stopDetails);
      stopDetailsList.push(stopDetails);
    });
  } else {
    return 'Missing requried parametres';
  }
  return stopDetailsList;
};
const getLoadPrice = (load:any)=>{
  return load && load.rate && load.rate.totalCharge ? load.rate.totalCharge : 'Contact to Book';
}
export const getYearValues = () => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const years = [currentYear];
  if (currentMonth === 11) {
    years.push(currentYear + 1);
  }
  if (currentMonth === 0) {
    years.push(currentYear - 1);
  }
  return years;
};

const showInitialDriverName=(showInitial: boolean | undefined, load: any, stopDetails: any) =>{
  if (showInitial) {
    let name = 'U';
    let driverName = load.shipmentInvolvedParties && load.shipmentInvolvedParties.filter((data: any) => {
      return data.partyType === 'PRIMARY DRIVER';
    });
    driverName = driverName.length ? driverName[0].partyName : '';
    name = getDriverName(driverName, name);
    stopDetails.driverName = name;
  }
}

const getDestination=(destination: any, stopDetails: any, idProp: string, fdProp: string) =>{
  if (destination) {
    stopDetails.destination_city = `${destination.city}, ${destination.state}`;
    stopDetails.destination_from_date =
      idProp === 'shipmentId'
        ? getAppointmentTime(destination)
        : getTime(destination[fdProp] || '', destination[fdProp] || '');
    stopDetails.destination_deadhead = destination.deadHead;
    stopDetails.destination_load_type = getStopService(destination);
  }
}

const getOrigin=(origin: any, stopDetails: any, idProp: string, fdProp: string, tdProp: string) =>{
  if (origin) {
    stopDetails.origin_city = `${origin.city}, ${origin.state}`;
    stopDetails.origin_from_date =
      idProp === 'shipmentId'
        ? getAppointmentTime(origin)
        : getTime(origin[fdProp] || '', origin[tdProp] || '');
    stopDetails.origin_deadhead = origin.deadHead;
    stopDetails.origin_load_type = getStopService(origin);
  }
}

const getDriverName=(driverName: any, name: string)=> {
  if (driverName) {
    const fName = driverName.slice(0, 1);
    const LName = driverName.indexOf(' ') > 0
      ? driverName.slice(driverName.indexOf(' ') + 1, driverName.indexOf(' ') + 2)
      : '';
    name = fName.toUpperCase() + LName.toUpperCase();
  }
  return name;
}

const idDrop=(idProp: string, loadStop: any) =>{
  if (idProp !== 'shipmentId') {
    loadStop =
      loadStop &&
      loadStop.filter((stop: any) => {
        return stop.stopType !== 'NFR';
      });
  }
  return loadStop;
}

const getLoadStopOriginDetails=(loadStop: any) =>{
  return loadStop && loadStop[0];
}

const getDestinationDetails=(loadStop: any) =>{
  return loadStop && loadStop.slice(-1)[0];
}

export function getMonth(month: number): string {
  switch (month) {
    case 0:
      return 'Jan';
    case 1:
      return 'Feb';
    case 2:
      return 'Mar';
    case 3:
      return 'Apr';
    case 4:
      return 'May';
    case 5:
      return 'Jun';
    case 6:
      return 'Jul';
    case 7:
      return 'Aug';
    case 8:
      return 'Sep';
    case 9:
      return 'Oct';
    case 10:
      return 'Nov';
    case 11:
      return 'Dec';
    default:
      return '';
  }
}